export { CollectiblesViewWingfeather } from './CollectiblesViewWingfeather'
